import React from 'react';
import '../styles/gallery.css';

const Gallery = () => {
  return (
    <div className="container">
      <div className="textgallery12">
        Featured
      </div>
      <div className="row">
        <div className="col-md-4 mb-2">
          <div className="gallery-item">
          <img src={require('../images/gallery/1.jpg')} alt="Image 1" className="gallery-image"   />
            <div className="description">The papaya, papaw, or pawpaw is the plant species Carica papaya, 
              one of the 21 accepted species in the genus Carica of the 
              family Caricaceae, and also the name of its fruit. 
              It was first domesticated in Mesoamerica, within modern-day 
              southern Mexico and Central America. </div>
          </div>
        </div>
        <div className="col-md-4 mb-2">
          <div className="gallery-item">
            <img src={require('../images/gallery/2.jpg')} alt="Image 2" className="gallery-image"  />
            <div className="description">Theobroma cacao is a evergreen tree in the Malvaceae family.
              Its seeds cocoa beans are used to make chocolate liquor, 
              cocoa solids, cocoa butter and chocolate. Although the tree 
              is native to the tropics of the Americas, the largest producer 
              of cocoa beans in 2022 was Ivory Coast. </div>
          </div>
        </div>
        <div className="col-md-4 mb-2">
          <div className="gallery-item">
            <img src={require('../images/gallery/3.jpg')} alt="Image 3" className="gallery-image"  />
            <div className="description">Kamias is a fruit-bearing tree of the genus Averrhoa, 
              family Oxalidaceae. It is cultivated in parts of tropical South Asia and the Americas. 
              It bears edible but extremely sour fruits. It is a close relative of the carambola 
              tree.</div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 mb-2">
          <div className="gallery-item">
            <img src={require('../images/gallery/4.jpg')} alt="Image 4" className="gallery-image" />
            <div className="description">Calamansi is a citrus hybrid cultivated predominantly in the 
              Philippines. It is naturally very sour, and is used in various condiments, beverages, 
              dishes, marinades, and preserves.</div>
          </div>
        </div>
        <div className="col-md-4 mb-2">
          <div className="gallery-item">
            <img src={require('../images/gallery/5.jpg')} alt="Image 5" className="gallery-image"  />
            <div className="description">Mansanitas is a Filipino term referring to the fruits of the
               Muntingia calabura tree, also known as aratiles, datiles, or Jamaican cherry.</div>
          </div>
        </div>
        <div className="col-md-4 mb-2">
          <div className="gallery-item">
            <img src={require('../images/gallery/6.jpg')} alt="Image 6" className="gallery-image"  />
            <div className="description">Balimbing is a species of tree in the family Oxalidaceae native to 
              tropical Southeast Asia; it has a number of common names, including carambola, star fruit and 
              five-corner.</div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 mb-2">
          <div className="gallery-item">
            <img src={require('../images/gallery/7.jpg')} alt="Image 7" className="gallery-image"  />
            <div className="description">The pomegranate is a fruit-bearing, deciduous shrub in the 
              family Lythraceae, subfamily Punicoideae, that grows between 5 and 10 m tall. 
              Rich in symbolic and mythological associations in many cultures, it is thought 
              to have originated from Afghanistan and Iran before being introduced and exported 
              to other parts of Asia, Africa, and Europe.</div>
          </div>
        </div>
        <div className="col-md-4 mb-2">
          <div className="gallery-item">
            <img src={require('../images/gallery/8.jpg')} alt="Image 8" className="gallery-image"  />
            <div className="description">Cainito is a tropical tree of the family Sapotaceae. 
              It is native to the Isthmus of Panama, where it was domesticated.</div>
          </div>
        </div>
        <div className="col-md-4 mb-2">
          <div className="gallery-item">
            <img src={require('../images/gallery/9.jpg')} alt="Image 9" className="gallery-image"  />
            <div className="description">Linawin is a species of flowering plant in the family Rutaceae, 
              known commonly as orangeberry and gin berry. </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
